import { t } from "ttag";

import { ScreenLayout } from "@/app/components/layouts";
import { InactiveSubscriptionAlert } from "@/app/screens/home/sections/content/components";
import { usePortalUserStore } from "@/app/stores";
import { PaymentMethod } from "@/features/billing/components";
import { ActiveSubscriptions } from "@/features/billing/sections";
import {
  PaymentFailedFullscreenAlert,
  PaymentSucceededFullscreenAlert,
} from "@/features/payments/components";
import { useHandleKlarnaRedirect } from "@/features/products/hooks";
import { LogoLoader } from "@/shared/components";
import { SUBSCRIPTION_STATUS } from "@/shared/domains";
import { usePageTitle } from "@/shared/hooks";
import { BillingHeader, PaymentHistory } from "./sections";

export const Overview = () => {
  usePageTitle(t`Billing`);

  const subscriptions =
    usePortalUserStore((state) => state.portalUser?.subscriptions) ?? [];

  const {
    isRedirect,
    isVerifyingPayment: isVerifyingPayment,
    isSucceededPayment: isSucceededPayment,
    isFailedPayment: isFailedPayment,
  } = useHandleKlarnaRedirect();

  const showRedirectionLoader = isRedirect && isVerifyingPayment;
  const showRedirectionSuccessAlert = isRedirect && isSucceededPayment;
  const showRedirectionErrorAlert = isRedirect && isFailedPayment;

  return (
    <ScreenLayout>
      <BillingHeader />

      {!subscriptions.length && (
        <InactiveSubscriptionAlert
          subscriptionStatus={SUBSCRIPTION_STATUS.CANCELLED}
        />
      )}

      <div className="flex flex-col gap-4 xl:flex-row">
        <ActiveSubscriptions className="xl:w-3/5" />
        <PaymentMethod className="max-h-64 xl:w-2/5" />
      </div>

      <PaymentHistory />

      <LogoLoader show={showRedirectionLoader} fullscreen>
        {t`We are verifying your payment, please wait a moment`}
      </LogoLoader>

      <PaymentSucceededFullscreenAlert open={showRedirectionSuccessAlert} />
      <PaymentFailedFullscreenAlert open={showRedirectionErrorAlert} />
    </ScreenLayout>
  );
};
